
  import { Vue, Component, Prop } from "vue-property-decorator";
  import moment from "moment";

  import UPDATE_NOTIFICATIONS from "@/apollo/notifications/UpdateNotifications.gql";
  import DELETE_NOTIFICATION from "@/apollo/notifications/DeleteNotification.gql";

  import UIButton from "@/components/button/ui-button.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      UIButton,
      LoadingOverlay,
    },
  })
  export default class NotificationItem extends Vue {
    @Prop({ type: String, required: true }) readonly notificationId!: string;
    @Prop({ type: String, required: true }) readonly message!: string;
    @Prop({ type: String, required: true }) readonly createdAt!: string;
    @Prop({ type: Boolean, required: true }) readonly read!: boolean;
    @Prop({ type: String, default: undefined }) readonly link!: string;

    processing: boolean = false;

    get formattedData(): string {
      return moment(this.createdAt).format("hh:mm a DD-MMM-YYYY");
    }

    get datetime(): string{
      return moment(this.createdAt).format();
    }

    openLink(): void {
      this.$emit("close");
      this.$router.push({
        path: this.link,
      });
      this.markNotificationAsRead();
    }

    async markNotificationAsRead(): Promise<void> {
      this.processing = true;

      try {
        await this.$apollo.mutate({
          mutation: UPDATE_NOTIFICATIONS,
          variables: {
            _set: {
              read: true,
            },
            where: { id: { _eq: this.notificationId } },
          },
        });
        this.$emit("notificationRead", this.notificationId);
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      } finally {
        this.processing = false;
      }
    }

    async deleteNotification(): Promise<void> {
      this.processing = true;

      try {
        await this.$apollo.mutate({
          mutation: DELETE_NOTIFICATION,
          variables: {
            id: this.notificationId,
          },
        });
        this.$emit("notificationDeleted", this.notificationId);
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      } finally {
        this.processing = false;
      }
    }
  }
